import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService, IAppSettings } from '../../services/configuration/configuration.service';
import { EnvironmentColourEnum, Node } from './navigation.types';
import { NavigationService } from './navigation.service';

@Component({
  selector: 'oir-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationComponent {
  transparentLogo = true;

  constructor(
    public navigationService: NavigationService,
    private configuration: ConfigurationService<IAppSettings>,
    private router: Router
  ) {}

  getEnvironmentColour(): string {
    const endpoint = this.configuration.getValue('CommsEndpoint');
    const env =  endpoint ? endpoint.url : '';
    let environmentColour: string;
    switch (true) {
      case env.includes('dev'):
        environmentColour = EnvironmentColourEnum.Development;
        break;
      case env.includes('localhost'):
        environmentColour = EnvironmentColourEnum.Development;
        break;
      case env.includes('systemtest'):
        environmentColour = EnvironmentColourEnum.SystemTest;
        break;
      case env.includes('bpt'):
        environmentColour = EnvironmentColourEnum.Bpt;
        break;
      case env.includes('prelive'):
        environmentColour = EnvironmentColourEnum.Prelive;
        break;
      default:
        environmentColour = EnvironmentColourEnum.Default;
        this.transparentLogo = false;
    }

    return environmentColour;
  }

  public expandHead(): void {
    this.navigationService.expandHead();
  }

  public clearSelect(node: Node): void {
    this.navigationService.clearSelect(node);
  }

  public toggle(node: Node): void {
    this.navigationService.toggle(node);
  }

  public select(node: Node): void {
    this.navigationService.select(node);
  }

  public navigate(url: string): void {
    window.location.href = url;
  }

  public keypressNavContainer(event, level): void {
    if (event.which === 13) {
      this.select(level);
      this.router.navigateByUrl(level.path);
    }
  }
}
